import { Link } from "react-router-dom";

const quickLinks = [
  { label: "最新电影", to: "/category/movie" },
  { label: "热播电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "站内搜索", to: "/search?q=" },
];

const friendLinks = [
  { label: "影视观察周报", to: "/news" },
  { label: "影视资料库", to: "/category/movie" },
  { label: "剧集风向标", to: "/category/tv" },
  { label: "观影指南", to: "/news" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-accent-950">
                <i className="ri-film-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-logo text-2xl tracking-wide text-background-50">
                茶杯狐影视
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">
              汇聚精彩电影与电视剧资源，分类清晰、浏览便捷，助你轻松发现每一部想看的好作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-primary-100">
                <i className="ri-mail-line" aria-hidden="true" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-primary-100">
                <i className="ri-wechat-line" aria-hidden="true" />
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-primary-100">
                <i className="ri-weibo-line" aria-hidden="true" />
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              快速导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              友情链接
            </h3>
            <ul className="mt-4 space-y-2.5">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">
              联系我们
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-primary-200">
              <li className="flex items-center gap-2">
                <i className="ri-service-line text-accent-400" aria-hidden="true" />
                合作与建议：hi@chabeihu-demo.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-accent-400" aria-hidden="true" />
                内容纠错：feedback@chabeihu-demo.cn
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-400" aria-hidden="true" />
                本站内容均为演示示例
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-900 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 茶杯狐影视 · 本站所有图片与信息均为演示示例，不提供任何真实播放或下载服务。</p>
          <p className="flex items-center gap-4">
            <span>隐私说明</span>
            <span>使用条款</span>
            <span>网站地图</span>
          </p>
        </div>
      </div>
    </footer>
  );
}